var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Alert, Box, Button, ThemeProvider, } from '@kareo/design-system';
import { Typography } from '@material-ui/core';
import getDesignSystemTheme from 'shared-assets/lib/utils/getDesignSystemTheme';
import styled from 'styled-components';
var AlertWithActionStyled = styled(Alert)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .MuiAlert-action {\n    flex-shrink: 0;\n  }\n  p.MuiTypography-root {\n    margin: 0;\n  }\n"], ["\n  .MuiAlert-action {\n    flex-shrink: 0;\n  }\n  p.MuiTypography-root {\n    margin: 0;\n  }\n"])));
export function PaymentErrorBox(_a) {
    var message = _a.message, href = _a.href, label = _a.label;
    return (React.createElement(AlertWithActionStyled, { severity: "error", action: React.createElement(ErrorAction, { href: href }, label) },
        React.createElement(Box, { display: "flex", flexDirection: "row" },
            React.createElement(Box, { flexGrow: 1 },
                React.createElement(Typography, { variant: "body2" }, message)))));
}
function ErrorAction(props) {
    return React.createElement(Button, __assign({ size: "small", color: "inherit", variant: "text" }, props));
}
export default function PaymentErrorBoxWithTheme(props) {
    var dsTheme = getDesignSystemTheme();
    return (React.createElement(ThemeProvider, { theme: dsTheme },
        React.createElement(PaymentErrorBox, __assign({}, props))));
}
var templateObject_1;
